import { makeStyles, shorthands } from '@fluentui/react-components';
import { linkGreen } from '../Shared/Shared';

export const useCareerPathStyles = makeStyles({
  link: {
    marginLeft: '10px',
    color: linkGreen,
    fontSize: '16px',
    fontWeight: 400,
    textDecorationLine: 'underline',
    ':hover': {
      textDecorationLine: 'underline',
    },
    ':focus': {
      textDecorationLine: 'underline',
    },
  },
  skeletonItem: {
    marginTop: '24px',
    height: '202px',
  },
  error: {
    rowGap: '16px !important',
  },
  skeletonContainer: {},
  secondThirdRow: {
    alignItems: 'center',
    display: 'grid',
    paddingBottom: '10px',
    position: 'relative',
    ...shorthands.gap('10px'),
    gridTemplateColumns: '33% 33%',
  },
});
